













import { Component, Vue } from "vue-property-decorator";
import { USER_ME, UserMeData } from "@/graphql/query/user/me";

import RoomListCheckbox from "@/containers/RoomListCheckbox.vue";
import AppUsersSelect from "@/containers/AppUsersSelect.vue";
import CButton from "@/basics/buttons/CButton.vue";
import NoteBox from "@/basics/boxes/NoteBox.vue";

@Component({
  components: {
    RoomListCheckbox,
    AppUsersSelect,
    CButton,
    NoteBox
  },
  apollo: {
    groupId: {
      query: USER_ME,
      update(data: UserMeData): string {
        return data.me.group.id;
      }
    }
  }  
})
export default class BuildingAppRelation extends Vue {
  get loading(): boolean {
    return this.$apollo.loading;
  }

  get appUserId(): string {
    return this.$route.params.appUserId;
  }

  selectAppUser(value: string) {
    this.$router.push({
      name: "building-app-relation-select",
      params: { appUserId: value }
    });
  }

  groupId: string = "";

}
